import React from 'react'

function IconButton({ children, icon, ...rest }) {
    return (
        <button {...rest} className={`text-base md:text-lg flex items-center gap-2 text-white rounded-full bg-primary p-2 ${rest.className} ${!icon && 'justify-center'}`} >
            {icon && icon}
            {children}
        </button>
    )
}

export default IconButton